import base from "@/store/utils/api-route/base";

const api = {
    getListPerangkat: `${base.masterData}whatsapp/list_perangkat_wa`,
    getDetailTinyDevice: `${base.masterData}whatsapp/detail_device_wa_tiny`,
    getWaStoryIndex: `${base.masterData}whatsapp/story/list_story_wa_all`,
    getStoryAktif: `${base.masterData}whatsapp/story/list_story_aktif`,
    getRiwayatStory: `${base.masterData}whatsapp/story/list_riwayat_story`,
    getDetailStory: `${base.masterData}whatsapp/story/detail_story`,
    createStatusNow: `${base.masterData}whatsapp/story/upload_now`,
    createStatus: `${base.masterData}whatsapp/story/upload_schedule`,
    updateStatus: `${base.masterData}whatsapp/story/update_wa_story`,
    takeDownStory: `${base.masterData}whatsapp/story/revoke_story_wa`,
    getDetailStatus: `${base.masterData}whatsapp/story/detail_schedule`,
    getDetailStatusTn: `${base.masterData}whatsapp/story/detail_schedule_tiny`,
    toggleStatus: `${base.masterData}whatsapp/story/change_status_enable_schedule`,
    getListAktivitas: `${base.masterData}whatsapp/story/list_aktivitas_schedule`,
};

export default api;
